import { useGetCurrentBoard } from 'entities/board/api/hooks/useGetCurrentBoard';
import { getHasHateoasAccess } from 'helpers';

export const useCanCreateTemplate = () => {
  const { board } = useGetCurrentBoard();

  return getHasHateoasAccess('createTemplate', board?.__links);
};
